import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advanced-filters',
  templateUrl: './advanced-filters.component.html',
  styleUrls: ['./advanced-filters.component.scss']
,  standalone: false
})
export class AdvancedFiltersComponent implements OnInit {


  ngOnInit() {
    //This blank function is mandatory
  }

}
